exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{border-color:red;background:#fdd}.error:focus{outline-color:#f99}.nice-select .current{width:-webkit-fill-available!important;display:block;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33b19cec","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/BusinessPartners.vue
// module id = 373
// module chunks = 0